import { checkForAccess } from 'rp-auth';
import * as segmentio from 'rp-analytics';
import moment from 'moment';

/**
 * @ngdoc service
 * @name CommonUtils.raceReplay
 */
export default class {
    constructor($http, $q, $cacheFactory, browserDetectService) {
        'ngInject';

        Object.assign(this, {
            $http,
            $q,
            fullReplayCache: new $cacheFactory('fullReplayCache'),
            closingStagesCache: new $cacheFactory('closingStagesCache'),
            fullReplayCacheExpired: true,
            closingStagesCacheExpired: true,
            browserDetectService,
            segmentio,
        });
    }

    cacheExpirationCheck = (isFullClick) => {
        const cacheName = this.getCacheName(isFullClick);
        const cacheExpiredName = `${cacheName}Expired`;
        if (this[cacheExpiredName]) {
            this.clearCache(cacheName);
            this[cacheExpiredName] = false;
            setTimeout(() => { this[cacheExpiredName] = true; }, 20000);
        }
    }

    clearCache = (cacheName) => this[cacheName].removeAll();

    getCacheName = isFullClick => (isFullClick ? 'fullReplayCache' : 'closingStagesCache');

    getDate = () => window.location.pathname.split('/')[4].replace(/-/g, '');

    enterFullScreen = (video) => {
        if (video.requestFullscreen) {
            video.requestFullscreen();
            return;
        }
        if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
            return;
        }
        if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
            return;
        }
        if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
            return;
        }
    };

    exitFullScreen = () => {
        // There are different full-screen API in browsers and versions
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
            return;
        }
        if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            return;
        }
        if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
            return;
        }
        if (document.webkitExitFullScreen) {
            document.webkitExitFullScreen();
            return;
        }
        if (document.msExitFullscreen) {
            document.msExitFullscreen();
            return;
        }
    };

    trackVideoReplay = (data, isFullClick, scope) => {
        const params = Object.assign(
            {
                feed_supplier: scope.provider,
                video_provided: !data.error,
            },
            this.getVideoParams(isFullClick, scope)
        );
        this.segmentio.track('Video Replay', params);

        return data.error ? this.$q.reject(data) : data;
    }

    onRequestFailed = (err, onError, isFullClick, scope) => {
        const cacheName = this.getCacheName(isFullClick);
        this.clearCache(cacheName);

        if (err.status === 0) {
            return this.$q.reject();
        }

        onError(err.error || err.data.error);

        if (err.status === 401) {
            this.trackVideoReplay({ error: true }, isFullClick, scope);
            checkForAccess('Subscriptions', true, false, { r: `${window.location}` });
        } else {
            console.warn(err);
        }

        return this.$q.reject();
    };

    getClickLocation = () => {
        const { hash } = window.location;
        if (hash.includes('resultList')) {
            return 'Result List';
        }
        if (hash.includes('profiles')) {
            return 'Profiles';
        }
        return 'In Player';
    }

    getVideoUrl = ({ provider, videoId, datetime }) => {
        const date = moment(datetime).format('YYYYMMDD');

        return `stream/${provider}/${videoId}/${date}`;
    }

    getVideoParams = (isFullClick, { raceId, raceName, datetime, raceTime, courseName }) => ({
        race_id: raceId,
        race: raceName,
        date: datetime,
        replay_type: isFullClick ? 'Full Replay' : 'Closing Stages',
        location: this.getClickLocation(),
        race_time: raceTime,
        racecourse: courseName,
    });

    getVideo = (isFullClick, scope, onError) => {
        this.cacheExpirationCheck(isFullClick);

        const { provider } = scope;

        if (provider === 'ATR') {
            return this.$http
            .get(
                this.getVideoUrl(scope), {
                    cache: isFullClick ? this.fullReplayCache : this.closingStagesCache,
                    headers: { 'X-Disable-Redirect': true },
                    timeout: scope.requestCanceler.promise,
                })
            .then(({ data }) => data)
            .then(data => this.trackVideoReplay(data, isFullClick, scope))
            .catch(err => this.onRequestFailed(err, onError, isFullClick, scope));
        }

        const { ptvAssetId } = scope;
        // eslint-disable-next-line max-len
        return fetch(`${window.location.origin}/api/ruk-stream/?ptvAssetId=${ptvAssetId}&v=${Date.now()}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then((data) => data)
            .then(data => this.trackVideoReplay(data, isFullClick, scope))
            .catch(err => this.onRequestFailed(err, onError, isFullClick, scope));
    }

}



// WEBPACK FOOTER //
// ./src/js/services/raceReplayService.js